<sbnb-apps-detail-page
  vendorCode="resortcleaning"
  name="ResortCleaning"
  logoTile="/assets/images/apps/resortcleaning.png"
  builtBy="ResortCleaning"
  [categories]="['Operations']"
  [permissions]="[AppPermission.calendarRead, AppPermission.propertyRead, AppPermission.enrichmentRead]"
  email="help@resortcleaning.com"
  [beta]="true"
  [helpArticles]="[{ id: '8857368', title: 'How to connect to ResortCleaning' }]">
  <ng-container description>
    <p>Connect Hospitable to ResortCleaning to automatically schedule departure cleans based on your reservations.</p>
    <sbnb-image-carousel
      [images]="[
        '/assets/images/apps/resortcleaning/RC_Dashboard.png',
        '/assets/images/apps/resortcleaning/StatusCenter.png',
        '/assets/images/apps/resortcleaning/ViewAppts.png',
        '/assets/images/apps/resortcleaning/App_Settings.png',
        '/assets/images/apps/resortcleaning/HSKP_AppCalView.png',
        '/assets/images/apps/resortcleaning/HSKP_Tasks.png',
        '/assets/images/apps/resortcleaning/INSP_List.png',
        '/assets/images/apps/resortcleaning/INSP_Details.png'
      ]"></sbnb-image-carousel>
  </ng-container>
</sbnb-apps-detail-page>
